<template>
	<div class="pills-history">
		<input-date-picker @input="onControlDatePickerInput"/>
		<spinner v-if="pills.loading || pillstaken.loading"/>
		<div v-if="pillstaken.data.length" class="idi-table pills">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.type') }}</div>
				<div class="idi-cell">{{ $t('labels.general.name') }}</div>
				<div class="idi-cell">{{ $t('labels.general.hour') }}</div>
				<div class="idi-cell">{{ $t('labels.general.status') }}</div>
				<div class="idi-cell">{{ $t('labels.general.feel') }}</div>
			</div>
			<div class="idi-row" v-for="pilltaken in pillstaken.data" :key="pilltaken.id">
				<div class="idi-cell grid-area-type">
					<shape :src="svgSrc(pilltaken.pill.type)" :class="svgClass(pilltaken.pill.color)" class="pill-svg"/>
				</div>
				<div class="idi-cell grid-area-name">
					<span class="label mobile">{{ $t('labels.general.name') }}</span>
					<span>{{ pilltaken.pill.name }}</span>
				</div>
				<div class="idi-cell grid-area-hour">
					<span class="label mobile">{{ $t('labels.general.hour') }}</span>
					<span>{{ formatHour(pilltaken.create_time) }}</span>
				</div>
				<div class="idi-cell grid-area-status">
					<span class="label mobile">{{ $t('labels.general.status') }}</span>
					<span>{{ status(pilltaken.status) }}</span>
				</div>
				<div class="idi-cell grid-area-feel">
					<span class="label mobile">{{ $t('labels.general.feel') }}</span>
					<span>{{ feel(pilltaken.feel) }}</span>
				</div>
			</div>
		</div>
		<p v-if="!(pills.loading || pillstaken.loading) && !pillstaken.data.length" class="no-results">{{ $t('base.general.no_results') }}</p>
	</div>
</template>

<script>
import clamp from '@/utils/clamp'
import Pill from '@/classes/Pill'
import PillTaken from '@/classes/PillTaken'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			pills: {
				loading: false,
				error: null,
				data: []
			},
			pillstaken: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	computed: {
		status_map () {
			return new Map([
				[1, { text: this.$t('labels.general.take_later') }],
				[2, { text: this.$t('labels.general.take') }],
				[3, { text: this.$t('labels.general.skip') }],
				[4, { text: this.$t('labels.general.miss') }]
			])
		},
		feel_map () {
			return new Map([
				[1, { text: this.$t('labels.general.better') }],
				[2, { text: this.$t('labels.general.same') }],
				[3, { text: this.$t('labels.general.worse') }]
			])
		},
		colors () {
			return Pill.colors()
		},
	},
	methods: {
		svgSrc (type) {
			return `/static/svg/pills/${this.numToShape(type)}.svg`
		},
		svgClass (color) {
			return `color-${this.numToColor(color)}`
		},
		numToShape (n) {
			return `shape${n.toString().padStart(2, 0)}`
		},
		numToColor (n) {
			n = clamp(parseInt(n), 0, this.colors.length - 1)
			return this.colors[n]
		},
		formatHour (datetime) {
			return this.$moment(datetime).format('HH:mm')
		},
		status (value, property = 'text') {
			let status = this.status_map.get(parseInt(value))
			return status ? status[property] : ''
		},
		feel (value, property = 'text') {
			let feel = this.feel_map.get(parseInt(value))
			return feel ? feel[property] : ''
		},
		getPillsAll () {
			this.pills.loading = true
			this.pills.data = []
			this.$api.pillbox2.getAll(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch pillbox', 'pillbox.getAll OK', response)()
				this.pills.data = Pill.processResponse(response.body)
				const day = this.$moment().format('YYYY-MM-DD')
				this.getPillsTakenByDay(day)
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.getAll ERROR', error)()
				this.pills.error = error
			}).finally(() => {
				this.pills.loading = false
			})
		},
		getPillsTakenByDay (day) {
			this.pillstaken.loading = true
			this.pillstaken.data = []
			this.$api.pillbox2.pillstaken.getByDay(this, this.user_uid, this.watch_id, day).then(response => {
				this.$log.info('watch pillbox', 'pillbox.getByDay OK', response)()
				this.pillstaken.data = PillTaken.processResponse(response.body, this.pills.data)
			}).catch(error => {
				this.$log.error('watch pillbox', 'pillbox.getByDay ERROR', error)()
				this.pillstaken.error = error
			}).finally(() => {
				this.pillstaken.loading = false
			})
		},
		onControlDatePickerInput (date) {
			this.getPillsTakenByDay(date)
		}
	},
	mounted () {
		this.getPillsAll()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/pillboxV2/PillsHistory.vue